export default __webpack_public_path__ + "static/media/pgcps_year_end_report.ec2952e1.png";